export const gis = {
  namespaced: true,
  namespace: 'gis',
  state: {
    searchGisButton: false
  },
  mutations: {
    setSearchGisButton(state, searchGisButton) {
      state.searchGisButton = searchGisButton;
    }
  },
  getters: {
    searchGisButton: state => state.searchGisButton
  },
  actions: {
    changeSearchGisButton({ commit }, flag) {
      commit('searchGisButton', flag);
    }
  }
};
